import { ReactNode, useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAuthStore } from "@/store/authStore"

interface Props {
  children: ReactNode
}

export function RequireAuth({ children }: Props) {
  const { user, token, loading, initFromStorage } = useAuthStore()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!token) {
      initFromStorage()
    }
  }, [token, initFromStorage])

  useEffect(() => {
    if (!loading && !user) {
      navigate("/login", { state: { from: location.pathname } })
    }
  }, [loading, user, navigate, location])

  if (loading || !user) {
    return null
  }

  return <>{children}</>
}

